export const GET_SINGLE_POST = 'GET_SINGLE_POST'
export const LOAD_SINGLE_POST = 'LOAD_SINGLE_POST'
export const LOAD_SINGLE_POST_REF = 'LOAD_SINGLE_POST_REF'
export const LOAD_SINGLE_POST_DATA = 'LOAD_SINGLE_POST_DATA'
export const MERGE_SINGLE_POST = 'MERGE_SINGLE_POST'
export const RESET_SINGLE_POST_ACTION = 'RESET_SINGLE_POST_ACTION'
export const RESET_SINGLE_POST = 'RESET_SINGLE_POST'
export const EXIST_PUBLICATION_SINGLE_POST = 'EXIST_PUBLICATION_SINGLE_POST'
// Mutations
export const SAVE_SINGLE_POST_REF = 'SAVE_SINGLE_POST_REF'
export const SAVE_SINGLE_POST_DATA = 'SAVE_SINGLE_POST_DATA'
export const MERGE_SINGLE_POST_DATA = 'MERGE_SINGLE_POST_DATA'



// WEBPACK FOOTER //
// ./src/store/actions/singlePostQueries.js